import { Dialog } from "@progress/kendo-react-dialogs"
import './style/payment-loader.css';

/* Source: https://codepen.io/orgi/pen/EraBMw */
function PaymentLoader() {
    return (
        <Dialog height={250}>
            <div class="payment-loader">
                <div class="pad">
                    <div class="chip"></div>
                    <div class="line line1"></div>
                    <div class="line line2"></div>
                </div>
                <div class="loader-text">
                    Please wait while we process the payment
                </div>
            </div>
        </Dialog>
    )
}

export default PaymentLoader